import { gsap } from "@gsap";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Verhaal - Slider
 * Slug: verhaal_slider
 */


const initializeStorySlider = (layout) => {
	return new Swiper(layout.querySelector(".swiper-container"), {
			slidesPerView: 1.125,
			spaceBetween: 16,
			navigation: {
				nextEl: layout.querySelector(".slider-button-next"),
				prevEl: layout.querySelector(".slider-button-prev"),
			},
			breakpoints: {
				768: {
					slidesPerView: 2.25,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: 3
				}
			}
	});
};

const storySliderSelector = ".flex-layout.verhaal_slider-layout";
if (window.pkExperimentInit) {
	window.pkExperimentInit(storySliderSelector, initializeStorySlider);
} else {
	document.addEventListener("DOMContentLoaded", () => {
		document.querySelectorAll(storySliderSelector).forEach(initializeStorySlider);
	});
}
